import React from "react";
import { Container } from "react-bootstrap";
import ProjectLandscape from "./ProjectLandscape";
import Particle from "../Particle";
import TypeWriter from "../TypeWriter";
import TabWindow from "../TabWindow";
import intellicredit from "../../Assets/Projects/intellicredit.png";
import interxai from "../../Assets/Projects/interxai.png";
import incluverse from "../../Assets/Projects/incluverse.png";
import smartcity from "../../Assets/Projects/smartcity.png";

function Projects() {
  const projectsData = [
    {
      title: "IntelliCredit",
      subtitle: "AI Credit Appraisal & Automated Decisioning Engine",
      description: "Corporate credit appraisal backend integrating PDF OCR, GST anomaly detection, and an MCA research agent into a single automated decisioning pipeline. Automated CAM report generation with rule-based + AI approve/reject logic, cutting manual underwriting effort by 60%; containerized with Docker.",
      imgPath: intellicredit,
      ghLink: "https://github.com/Khushbu-github/Intellicredit",
      demoLink: "https://intellicredit-lilac.vercel.app",
      tags: ["FASTAPI", "PYTHON", "REACT", "DOCKER", "POSTGRESQL", "OCR"],
      category: "FINTECH AI",
      year: "2025"
    },
    {
      title: "Bengaluru Smart City Incident Analyzer",
      subtitle: "Civic Analytics & Real-Time Incident Hotspot Platform",
      description: "Civic-analytics platform fusing traffic, accident, and weather data feeds via REST APIs and distributed data pipelines for real-time hotspot detection. Built a LangChain retrieval-augmented generation (RAG) pipeline backing a geospatial dashboard; deployed full stack via Docker.",
      imgPath: smartcity,
      ghLink: "https://github.com/Khushbu-github/Bengaluru-Smart-City-Incident-Analyzer",
      tags: ["FASTAPI", "LANGCHAIN", "RAG", "DOCKER", "PYTHON", "GEOSPATIAL"],
      category: "CIVIC AI",
      year: "2024",
      customNumber: "02"
    },
    {
      title: "InterXAI",
      subtitle: "Multi-Agent AI Interview Platform",
      description: "Engineered a multi-agent interview platform coordinating resume parsing, live interview sessions, and facial analysis in a single Node.js-orchestrated pipeline. Designed candidate ingestion → scoring → AI feedback workflow using prompt engineering and multi-agent orchestration.",
      imgPath: interxai,
      ghLink: "https://github.com/Khushbu-github/InterXAI",
      tags: ["REACT", "NODE.JS", "GROQ LLM", "FACEAPI.JS", "MULTI-AGENT"],
      category: "HR TECH",
      year: "2025"
    },
    {
      title: "IncluVerse",
      subtitle: "Accessibility-First Digital Platform",
      description: "Accessibility-focused digital platform with voice commands, OCR, and community engagement features. Built to empower differently-abled users with intelligent assistive technologies.",
      imgPath: incluverse,
      ghLink: "https://github.com/Khushbu-github/IncluVerse-AIOP-For-Diabled",
      demoLink: "https://inclu-verse-aiop-for-diabled.vercel.app",
      tags: ["TESSERACT.JS", "LANGCHAIN", "VOICE AI", "ACCESSIBILITY"],
      category: "SOCIAL IMPACT",
      year: "2024"
    }
  ];

  return (
    <Container fluid className="project-section" id="projects">
      <Particle />
      <TabWindow
        activeTabId="projects"
        activeFileName="projects.py"
        activeIcon="🚀"
        language="PYTHON"
        lineCount="83"
      >
        <p className="terminal-cmd section-cmd">
          <span className="terminal-dollar">$</span>
          <TypeWriter text=" ls ./projects --sort=recent" speed={40} />
        </p>
        <h1 className="project-heading">
          <TypeWriter text="My " speed={60} cursor={false} />
          <TypeWriter text="Projects " speed={60} className="purple" tag="strong" />
        </h1>
        <p style={{ marginBottom: "50px" }}>
          A showcase of my recent engineering and AI research works.
        </p>
        
        {projectsData.map((project, index) => (
          <ProjectLandscape key={index} index={index} {...project} />
        ))}
      </TabWindow>
    </Container>
  );
}

export default Projects;
